import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { InputTel } from "components/formElements";
import { updateMissingDetails } from "actions/user";

import I18n from "lib/i18n/i18n";
import Validators from "lib/validators";

import { FacebookMessenger } from "../facebookMessenger";
import { imageUrl } from "helpers/ApplicationHelper";
import { getItem } from "actions/item";
import UserActions from "lib/userActions";
import { isDefaultPhone } from "helpers/ApplicationHelper";
import { browserHistory } from "react-router";

class MissingDetails extends Component {
  experimentsMounted = false;
  constructor(props) {
    super(props);

    this._validate = this._validate.bind(this);
    this._onSubmit = this._onSubmit.bind(this);
    this._clearAllErrors = this._clearAllErrors.bind(this);

    this.state = {
      missingPhone: this.props.missingPhone || true,
      valueCategory: (this.props.Item && this.props.Item.value_category) || "",
      showMessageUs: false,
      showNewPhoneLine: false,
    };

    this._validatePhone = this._validatePhone.bind(this);
    this._onSubmit = this._onSubmit.bind(this);
  }

  componentDidMount() {
    this._phone = this.refs["phone"];

    this.sendPagePresentedEvent();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.ADO && !nextProps.Item) {
      this.props.getItem(this.props.params.itemId || this.props.params.id);
    }

    // check if we want to show the messageUs button.
    if (!this.state.showMessageUs && this.shouldShowMessageUs(nextProps)) {
      this.setState({ showMessageUs: true }, () => {
        UserActions.missingDetails(
          "Facebook MessageUs button presented",
          this.props.params.itemId || this.props.params.id
        );
      });
    }

    //check if we want to show the new line in the trends exp or not
    if (
      !this.state.showNewPhoneLine &&
      this.shouldShowNewPhoneLine(nextProps)
    ) {
      this.setState({ showNewPhoneLine: true });
    }

    if (this.state.showMessageUs && nextProps.Item.high_value_estimation) {
      this.setState({ showMessageUs: false });
    }

    if (
      nextProps.ADO &&
      nextProps.ADO.user &&
      !isDefaultPhone(nextProps.ADO.user.phone) &&
      window.location.href.includes("missing-details")
    ) {
      browserHistory.push(window.location.href.replace("missing-details/", ""));
    }

    this.sendPagePresentedEvent();
  }

  sendPagePresentedEvent() {
    if (this.props.ADO && !this.pagePresentedEventSent) {
      this.pagePresentedEventSent = true;
      UserActions.missingDetails(
        "Missing details page presented, working hours " +
          this.props.ADO.working_hour,
        this.props.params.itemId || this.props.params.id
      );
    }
  }

  shouldShowMessageUs(props) {
    return (
      props.Item &&
      !props.Item.high_value_estimation &&
      props.Item.estimation !== undefined &&
      props.Item.high_value_estimation !== undefined && // undefiend assumes false. not good for us here.
      props.Experiments &&
      props.Experiments.missing_details_message_us &&
      props.Experiments.missing_details_message_us.status === true &&
      props.Experiments.missing_details_message_us.variant === "true" &&
      props.ADO &&
      props.ADO.working_hour === true
    );
  }

  shouldShowNewPhoneLine(props) {
    return (
      props.Experiments &&
      props.Experiments.send_trends_email &&
      props.Experiments.send_trends_email.variant === "true" &&
      props.Experiments.send_trends_email.status === true
    );
  }

  onVisibilityChanged() {
    if (this.aroundFrame && window.document.visibilityState === "hidden") {
      UserActions.missingDetails(
        "Message us button clicked.",
        this.props.params.itemId || this.props.params.id
      );
      console.log("opening messenger");
      // since a new window is opened, the user can move the mouse and not be affected by the event of mouseOut.
      // we don't want a repeated switch between windows to create multiple events in this case.
      this.aroundFrame = false;
    }
  }

  _clearAllErrors() {
    this._phone.clearErrors();
  }

  _validatePhone() {
    this._phone.clearErrors();
    if (Validators.validatePhone(this._phone.state.value)) {
      return Promise.resolve();
    } else {
      const proper_error_message =
        this._phone.state.value.length === 0
          ? "registerPage::form::errors::emptyPhone"
          : "registerPage::form::errors::phone";
      this._phone.setError(I18n.getString(proper_error_message));
      return Promise.reject();
    }
  }

  _validate() {
    return Promise.all([this._phone.props.validator()]);
  }

  _onSubmit(event) {
    event.preventDefault();

    this._clearAllErrors();

    this._validate().then(
      () => {
        let res = updateMissingDetails({
          phone: this._phone.state.value,
          user_id: this.props.ADO.user.id,
        });

        res.payload.then((response) => {
          console.log(response);
        });
      },
      () => {
        //
      }
    );
  }

  chooseSentenceFromExperiment() {
    return this.state.showNewPhoneLine ? "1" : "0";
  }

  render() {
    let imageLink = (this.props.ADO && this.props.ADO.user.image_url) || "",
      userName =
        (this.props.ADO &&
          this.props.ADO.user &&
          `${this.props.ADO.user.first_name} ${this.props.ADO.user.last_name}`) ||
        "",
      titleFirstLine = this.props.Experiments
        ? I18n.getString(
            "missingDetails::title::firstLine::" +
              this.chooseSentenceFromExperiment()
          )
        : "",
      titleSecondLine = this.props.Experiments
        ? I18n.getString(
            "missingDetails::title::secondLine::" +
              this.chooseSentenceFromExperiment()
          )
        : "",
      underCTALine = this.props.Experiments
        ? I18n.getString(
            "missingDetails::underCTA::firstLine::" +
              this.chooseSentenceFromExperiment()
          )
        : "";
    return (
      <div id="missing-details-form">
        <div className="missing-details-form">
          <div className="user-details-container">
            <span className="image-container">
              <img className="img-circle" src={imageLink} />
              <img
                className="fb-icon"
                src={imageUrl("common/facebook_icon.svg")}
              />
            </span>
            <div className="name">Hi, {userName}</div>
          </div>
          <span className="sub-h1 long">
            {titleFirstLine}
            <br />
            {titleSecondLine}
          </span>
          <span className="sub-h1 short">
            {titleFirstLine}
            <br />
            {titleSecondLine}
          </span>
          <form onSubmit={this._onSubmit} noValidate>
            <InputTel
              ref="phone"
              name="phone"
              inputId="register-phone-input"
              inputProps={{
                placeholder: I18n.getString(
                  "registerPage::form::phone::placeholder"
                ),
              }}
              validator={this._validatePhone}
            />
            <span className="sub-h2`">{underCTALine}</span>
            <div>
              <button type="submit" className="btn btn-gold">
                Continue
              </button>
            </div>
          </form>
        </div>
        {this.state.showMessageUs ? (
          <div style={{ textAlign: "center", paddingTop: "20px" }}>
            <span className={"sub-h2"}>
              {I18n.getString("missingDetails::underCTA::or")}
            </span>
            <div style={{ paddingTop: "20px" }}>
              <FacebookMessenger
                itemId={this.props.params.itemId || this.props.params.id}
              />
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = ({ Session, ADO, Item, Experiments }) => {
  return {
    Session,
    ADO,
    Item,
    Experiments,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ getItem }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(MissingDetails);
